import Seo from "@/components/Seo";
import { FAQ_ITEMS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FaqPage() {
  return (
    <main data-testid="faq-page" className="pt-28 md:pt-36 pb-24">
      <Seo
        title="Usein kysytyt kysymykset – JINSU"
        description="Vastauksia yleisimpiin kysymyksiin JINSU-suihkusuodattimista: toimitus, asennus, yhteensopivuus, vaihtoväli ja palautukset."
      />

      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <p className="eyebrow text-water-deep/80">UKK</p>
        <h1 className="h-display font-heading mt-5 font-semibold text-foreground" lang="fi">
          Usein kysytyt kysymykset
        </h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-muted-foreground">
          Vastauksia yleisimpiin kysymyksiin suodattimista, toimituksesta ja palautuksista.
        </p>

        <div className="mt-12 rounded-[2rem] bg-white p-6 md:p-10 shadow-[0_10px_40px_-18px_rgba(23,68,94,0.18)]">
          <Accordion type="single" collapsible>
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  className="text-left font-heading text-lg font-semibold"
                  data-testid={`faq-question-${i}`}
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base leading-relaxed text-muted-foreground">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </main>
  );
}
